module.exports = __webpack_public_path__ + "Lato-Bold.24b516c266d7341c954c.ttf";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/Lato/Lato-Bold.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-Bold.ttf
// module chunks = styles